import { LOAD_MOVIE_PLAYER_PAGE } from '@/store/protocols'
export default {
    name: 'movies/player',
    path: '/html/:id/:url?.html',
    component: () => import('./Root.vue'),
    meta: {
        asyncData: LOAD_MOVIE_PLAYER_PAGE.join('/')
    }
}